import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { Badge } from '@mui/material'
import React, { useContext } from "react"
import { AppContext } from "../context/AppContextProvider"

export default function CartIcon(props) {
    const { cart } = useContext(AppContext)

    let count = 0

    count = cart.contents.reduce((sum, item) => {
        return sum + item.quantity
    }, 0)

    return (
        <Badge badgeContent={count} color="primary">
            <ShoppingCartIcon />
        </Badge>
    )
}
